const documentMapService = {
  resetMap: () => {
    // Check if the map exists in local storage
    const existingMap = localStorage.getItem("DOCUMENT_MAP_SERVICE");

    if (!existingMap) {
      console.log("No map found to reset. The map is already cleared.");
      return;
    }

    // Remove the map from local storage
    localStorage.removeItem("DOCUMENT_MAP_SERVICE");
  },

  initializeMap: (totalPages) => {
    const existingMap = localStorage.getItem("DOCUMENT_MAP_SERVICE");
    let map = [];

    if (!existingMap) {
      for (let i = 0; i < totalPages; i++) {
        map[i] = -1;
      }
      localStorage.setItem("DOCUMENT_MAP_SERVICE", JSON.stringify(map));
    }
  },

  getPagePosition: (pageNumber) => {
    const existingMap = localStorage.getItem("DOCUMENT_MAP_SERVICE");

    if (!existingMap) {
      console.log("Map has not been initialized. Please call initializeMap first.");
      return null;
    }

    const map = JSON.parse(existingMap);

    if (pageNumber < 1 || pageNumber > map.length) {
      console.log(`Page number ${pageNumber} is out of bounds.`);
      return null;
    }

    return map[pageNumber - 1];
  },

  getDocumentPageNumber: (pagePosition) => {
    const existingMap = localStorage.getItem("DOCUMENT_MAP_SERVICE");

    if (!existingMap) {
      console.log("Map has not been initialized. Please call initializeMap first.");
      return null;
    }

    const map = JSON.parse(existingMap);

    const index = map.indexOf(pagePosition);

    if (index === -1) {
      return false;
    }

    return index + 1;
  },

  updateMap: (startPageNumberToUpdate, pagesCountToUpdate, startPagePosition) => {
    const existingMap = localStorage.getItem("DOCUMENT_MAP_SERVICE");

    if (!existingMap) {
      return;
    }

    const map = JSON.parse(existingMap);

    const startPageIndex = startPageNumberToUpdate - 1;
    if (startPageIndex < 0 || startPageIndex >= map.length) {
      console.log(`Start page number ${startPageNumberToUpdate} is out of bounds.`);
      return;
    }

    if (startPageIndex + pagesCountToUpdate > map.length) {
      console.log("Pages to update exceed map bounds.");
      return;
    }

    for (let i = 0; i < pagesCountToUpdate; i++) {
      const currentIndex = startPageIndex + i;

      map[currentIndex] = startPagePosition + i;
    }

    let newPosition = startPagePosition + pagesCountToUpdate;
    for (let i = startPageIndex + pagesCountToUpdate; i < map.length; i++) {
      if (map[i] !== -1) {
        map[i] = newPosition;
        newPosition++;
      }
    }

    localStorage.setItem("DOCUMENT_MAP_SERVICE", JSON.stringify(map));
  },

  determinePagePosition: (newPageNumber, lastPagePosition) => {
    const existingMap = localStorage.getItem("DOCUMENT_MAP_SERVICE");

    if (!existingMap) {
      console.log("Map has not been initialized. Please call initializeMap first.");
      return null;
    }

    const map = JSON.parse(existingMap);

    if (newPageNumber < 0 || newPageNumber > map.length) {
      console.log(`Start page number ${newPageNumber} is out of bounds.`);
      return null;
    }

    for (let i = lastPagePosition; i >= 0; i--) {
      let page = documentMapService.getDocumentPageNumber(i);
      if (newPageNumber > page) {
        return i + 1;
      }
    }

    return 0;
  },

  updatePagesList: (currentList, newPages, newIndexPosition) => {
    currentList = currentList.slice();
    const safeIndexPosition = Math.max(0, Math.min(newIndexPosition, currentList.length));
    currentList.splice(safeIndexPosition, 0, ...newPages);

    return currentList;
  },

  determinePageScrollPosition: (specificPage, totalPagesLoaded, totalDocumentHeight) => {
    return (totalDocumentHeight / totalPagesLoaded) * specificPage;
  },

  setScroll: (idClass, specificPage, totalPagesLoaded) => {
    var container_height = document.getElementsByClassName(idClass)[0];
    if (container_height) {
      const pagePosition = documentMapService.getPagePosition(specificPage);
      if (pagePosition === null || pagePosition === -1) {
        return false;
      }

      const pageElement = container_height.getElementsByClassName("pdf-images")[pagePosition];
      if (pageElement) {
        container_height.scrollTop = pageElement.offsetTop - container_height.offsetTop;
        return true;
      }

      if (!totalPagesLoaded) {
        return false;
      }

      var pageSize = container_height.scrollHeight / totalPagesLoaded;
      container_height.scrollTop = pageSize * pagePosition;
      return true;
    }

    return false;
  },

  determineNeighborPageNumberToFetch: (currentPage) => {
    const existingMap = localStorage.getItem("DOCUMENT_MAP_SERVICE");
    if (!existingMap) {
      console.log("Map has not been initialized. Please call initializeMap first.");
      return -1;
    }

    const map = JSON.parse(existingMap);
    const currentPageNumber = parseInt(currentPage, 10);
    if (isNaN(currentPageNumber) || currentPageNumber < 1 || currentPageNumber > map.length) {
      return -1;
    }

    const currentPageIndex = currentPageNumber - 1;
    const nextPageIndex = currentPageIndex + 1;

    if (
      map[currentPageIndex] === -1 ||
      nextPageIndex >= map.length ||
      map[nextPageIndex] !== -1
    ) {
      return -1;
    }

    return currentPageNumber + 1;
  }
};

export default documentMapService;
